// Vendor imports
const { connect } = require('react-redux')
// Shared imports
const { formatCount, pluralize } = require('shared/string-utils')
// Common client-v2 imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const articleModelConnect = require('client-v2/common/models/article/connect')
const deferDispatch = require('client-v2/common/state/dispatch')
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Container imports
const { getSlide } = require('../state/selectors')
const articleProfileSlideActions = require('../state/slide-actions')
const { TabNameEnum } = require('../state/slide-record')
const ArticleProfileDetailCard = require('./detail-card-dumb')

const Collections = pluralize('Collection')
const Comments = pluralize('Comment')

function mapStateToProps(state, props) {
  const slide = getSlide(state, props)
  const isMoreCollectionsAvailable = (
    slide.collectionsState !== FetchStateEnum.LOADING &&
    !!slide.collectionsMeta.get('nextUrl')
  )
  return {
    // Flags
    isMoreCollectionsAvailable,
    // Values
    article: slide.article,
    collections: slide.collectionsItems,
    comments: slide.commentsItems,
    tabs: {
      [TabNameEnum.COLLECTIONS]: collectionsTabState(slide),
      [TabNameEnum.COMMENTS]: commentsTabState(slide)
    },
    user: state.user
  }
}

function mapDispatchToProps(dispatch, props) {
  const { dispatchAction } = deferDispatch(dispatch)
  return Object.assign({
    onMoreCollectionsClick: dispatchMoreCollections(dispatch, props),
    onTabSelect: dispatchAction(articleProfileSlideActions.selectTab)
  },
    articleModelConnect.mapDispatchToProps(dispatch)
  )
}

function collectionsTabState(slide) {
  const { count } = slide.article
  const isLoading = slide.collectionsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Collections'
  : `In ${formatCount(count)} ${Collections(count)}`
  return {
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.COLLECTIONS,
    label
  }
}

function commentsTabState(slide) {
  const count = slide.commentsItems.size
  const isLoading = slide.commentsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Comments'
  : `${formatCount(count)} ${Comments(count)}`
  return {
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.COMMENTS,
    label
  }
}

function dispatchMoreCollections(dispatch, props) {
  return function () {
    dispatch(function (dispatch, getState) {
      const slide = getSlide(getState(), props)
      const { article, collectionsMeta } = slide
      const nextUrl = collectionsMeta.get('nextUrl')
      if (nextUrl) {
        dispatch(articleProfileSlideActions.loadCollections({ article, nextUrl }))
      }
    })
  }
}

// Exports

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    ArticleProfileDetailCard
  )
)

module.exports = SmartComponent
